import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './app/providers';
import { AppRouter } from './app/router';
import { AuthProvider } from './features/auth';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing from index.html');

createRoot(container).render(
  <StrictMode>
    <Providers>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Providers>
  </StrictMode>,
);
